import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedInputsStyleOverrides from './CustomizedInputsStyleOverrides';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedInputsStyleOverrides, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/customized-inputs-style-overrides/CustomizedInputsStyleOverrides.tsx",
    "fileName": "CustomizedInputsStyleOverrides.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import TextField from '@mui/material/TextField';\nimport { outlinedInputClasses } from '@mui/material/OutlinedInput';\nimport Box from '@mui/material/Box';\nimport { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\n\nconst customTheme = (outerTheme: Theme) =>\n  createTheme({\n    palette: {\n      mode: outerTheme.palette.mode,\n    },\n    components: {\n      MuiTextField: {\n        styleOverrides: {\n          root: {\n            '--TextField-brandBorderColor': '#E0E3E7',\n            '--TextField-brandBorderHoverColor': '#B2BAC2',\n            '--TextField-brandBorderFocusedColor': '#6F7E8C',\n            '& label.Mui-focused': {\n              color: 'var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiOutlinedInput: {\n        styleOverrides: {\n          notchedOutline: {\n            borderColor: 'var(--TextField-brandBorderColor)',\n          },\n          root: {\n            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {\n              borderColor: 'var(--TextField-brandBorderHoverColor)',\n            },\n            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {\n              borderColor: 'var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiFilledInput: {\n        styleOverrides: {\n          root: {\n            '&::before, &::after': {\n              borderBottom: '2px solid var(--TextField-brandBorderColor)',\n            },\n            '&:hover:not(.Mui-disabled, .Mui-error):before': {\n              borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',\n            },\n            '&.Mui-focused:after': {\n              borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiInput: {\n        styleOverrides: {\n          root: {\n            '&::before': {\n              borderBottom: '2px solid var(--TextField-brandBorderColor)',\n            },\n            '&:hover:not(.Mui-disabled, .Mui-error):before': {\n              borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',\n            },\n            '&.Mui-focused:after': {\n              borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n    },\n  });\n\nexport default function CustomizedInputsStyleOverrides() {\n  const outerTheme = useTheme();\n\n  return (\n    <Box\n      sx={{ display: 'grid', gridTemplateColumns: { sm: '1fr 1fr 1fr' }, gap: 2 }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={customTheme(outerTheme)}>\n        <TextField label=\"Outlined\" />\n        <TextField label=\"Filled\" variant=\"filled\" />\n        <TextField label=\"Standard\" variant=\"standard\" />\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 87,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import TextField from '@mui/material/TextField';\nimport { outlinedInputClasses } from '@mui/material/OutlinedInput';\nimport Box from '@mui/material/Box';\nimport { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\n\nconst customTheme = (outerTheme: Theme) =>\n  createTheme({\n    palette: {\n      mode: outerTheme.palette.mode,\n    },\n    components: {\n      MuiTextField: {\n        styleOverrides: {\n          root: {\n            '--TextField-brandBorderColor': '#E0E3E7',\n            '--TextField-brandBorderHoverColor': '#B2BAC2',\n            '--TextField-brandBorderFocusedColor': '#6F7E8C',\n            '& label.Mui-focused': {\n              color: 'var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiOutlinedInput: {\n        styleOverrides: {\n          notchedOutline: {\n            borderColor: 'var(--TextField-brandBorderColor)',\n          },\n          root: {\n            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {\n              borderColor: 'var(--TextField-brandBorderHoverColor)',\n            },\n            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {\n              borderColor: 'var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiFilledInput: {\n        styleOverrides: {\n          root: {\n            '&::before, &::after': {\n              borderBottom: '2px solid var(--TextField-brandBorderColor)',\n            },\n            '&:hover:not(.Mui-disabled, .Mui-error):before': {\n              borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',\n            },\n            '&.Mui-focused:after': {\n              borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n      MuiInput: {\n        styleOverrides: {\n          root: {\n            '&::before': {\n              borderBottom: '2px solid var(--TextField-brandBorderColor)',\n            },\n            '&:hover:not(.Mui-disabled, .Mui-error):before': {\n              borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',\n            },\n            '&.Mui-focused:after': {\n              borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',\n            },\n          },\n        },\n      },\n    },\n  });\n\nexport default function CustomizedInputsStyleOverrides() {\n  const outerTheme = useTheme();\n\n  return (\n    <Box\n      sx={{ display: 'grid', gridTemplateColumns: { sm: '1fr 1fr 1fr' }, gap: 2 }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={customTheme(outerTheme)}>\n        <TextField label=\"Outlined\" />\n        <TextField label=\"Filled\" variant=\"filled\" />\n        <TextField label=\"Standard\" variant=\"standard\" />\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 80
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "customTheme"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "outerTheme"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 81
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 82
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Filled",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "filled",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 83
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Standard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "standard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 84
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 87,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/TextField",
      "@mui/material/OutlinedInput",
      "@mui/material/Box",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
